import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseDeliveriesSearch } from "@/features/administration";
import { DeliveriesPage } from "@/features/administration/pages";
import { strictSearch } from "@/shared/lib/search";

/** What the partners were told of the orders made inside their apps. */
export const Route = createFileRoute("/_app/settings/partner-deliveries")({
  validateSearch: strictSearch(parseDeliveriesSearch),
  component: Deliveries,
});

function Deliveries() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <DeliveriesPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(delivery) =>
        router.buildLocation({
          to: "/settings/partner-deliveries",
          search: { ...search, delivery: delivery.id },
        }).href
      }
    />
  );
}
